import { render } from "./Home.vue?vue&type=template&id=27e3aaf0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=27e3aaf0&lang=css"
import "./Home.vue?vue&type=style&index=1&id=27e3aaf0&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\vue-argon-centrion\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e3aaf0"]])

export default __exports__